<div id="ht">
    <div id="main-cnt">

        <ion-header class="main-header block">
            <ion-toolbar class="blues-nav">
                <ion-buttons slot="start" class="nav-content">
                    <div size="2" class="nav-back">
              <span class="custom-icon-back-arrow-icon" (click)="back()">
                <span class="path1"></span> 
                <span class="path2"></span> 
              </span>
                        <span class="breadcrumb">
                            <span *ngIf="sessionService.user?.permessions === 'ADMINISTRATOR'">AMMINISTRATORE - </span>
                            <!--COMMERCIALE - I MIEI INVESTIMENTI - -->CONTRATTO {{ currentContract?.commercial?.lastname |titlecase }}
                            - {{ currentContract?.startDate }}</span>
                    </div>
                </ion-buttons>
                <div slot="end" class="notification-div">
                    <ion-avatar class="menu-user-icon" (click)="openPage('/my-profile')">
                        <img [src]="sessionService?.user?.profileImg|s3Link">

                    </ion-avatar>
                </div>
            </ion-toolbar>
            <br>

            <!-- edit da qui... -->

            <!-- ...a qui -->
        </ion-header>


        <ion-content class="main-content">
            <div class="scroller-container">
                <div class="content-scroller">
                    <div class="content tillBottom">
                        <!-- edit da qui... -->

                        <div class="glass-blurred-background padding full-width text-bold">
                            <img class="main-logo small svg-white" src="./assets/imgs/logo-blu.svg">
                            <div slot="end" class="edit-icons"
                                 *ngIf="sessionService.user?.permessions === 'ADMINISTRATOR' || (sessionService.user?.permessions === sessionService.permessionTypes.COMMERCIAL && currentContract?.status !== contractStatus.ACTIVE) ">
                                <span class="custom-icon-edit-icon" (click)="editContract()"></span>
                                <span class="custom-icon-delete-icon"
                                      (click)="deleteContract(currentContract.id)"></span>
                            </div>

                            <h2 class="contract-status">Status: {{ currentContract?.status }}</h2>

                            <div class="flex-row">
                                <div class="flex-grid-3 full">
                                    <div class="flex-1">
                                        <h6 class="contract-header">Created Date</h6>
                                        <span class="contract-sub">{{ currentContract?.date | date : 'd MMM y'}}</span>
                                    </div>
                                    <div class="flex-1">
                                        <h6 class="contract-header">Start Date</h6>
                                        <span class="contract-sub">{{ currentContract?.startDate | date : 'd MMM y'}}</span>
                                    </div>
                                    <div class="flex-1">
                                        <h6 class="contract-header">End Date</h6>
                                        <span class="contract-sub">{{ currentContract?.endDate | date : 'd MMM y'}}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="flex-row" *ngIf="currentContract?.extended">
                                <div class="flex-grid-3 full">
                                    <div class="flex-1">
                                        <h6 class="contract-header">Prorogato Da</h6>
                                        <span class="contract-sub">{{ currentContract?.extendedBy }}</span>
                                    </div>
                                    <div class="flex-1">
                                        <h6 class="contract-header">Prorogato dal</h6>
                                        <span class="contract-sub">{{ currentContract?.extendedFromDate | date : 'd MMM y'}}</span>
                                    </div>
                                    <div class="flex-1">
                                        <h6 class="contract-header">Prorogato il</h6>
                                        <span class="contract-sub">{{ currentContract?.extendedTimeStamp | date : 'd MMM y'}}</span>
                                    </div>
                                </div>
                            </div>

                            <br><br>

                            <div class="flex-row">
                                <div class="flex-grid-3 full">
                                    <div class="flex-1">
                                        <h6 class="contract-header">Commercial</h6>
                                        <span class="contract-sub">{{ currentContract?.commercial?.name |titlecase}} {{ currentContract?.commercial?.lastname |titlecase}}</span>
                                    </div>
                                    <div class="flex-1">
                                        <h6 class="contract-header">Client</h6>
                                        <span class="contract-sub">{{ utenti?.name |titlecase}} {{utenti?.lastname |titlecase}}</span>
                                    </div>
                                    <div class="flex-1">
                                        <h6 class="contract-header">Amount</h6>
                                        <span class="contract-sub">{{ currentContract?.amount |currency:'EUR' }}</span>
                                        -
                                        <span class="contract-sub">{{ currentContract?.percent + '%' }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="flex-row">
                                <div class="flex-left">Note</div>
                                <div class="float-right">{{currentContract?.notes}}</div>
                            </div>

                            <button (click)="open(currentContract?.file)" expand="block"
                                    class="button button-blue drop-shadow padding view-contract">View document
                            </button>
                        </div>

                        <!-- ...a qui -->
                    </div>
                </div>
            </div>

        </ion-content>

    </div>
</div>


<!-- <ion-header>
    <ion-toolbar class="blues-nav">
        <ion-row>
            <ion-col size="2" class="nav-back">
        <span class="custom-icon-back-arrow-icon" (click)="back()">
          <span class="path1"></span> <span class="path2"></span> </span>
            </ion-col>
            <ion-col size="10" class="nav-content">
                <ion-title>
                    <span class="breadcrumb"><span *ngIf="sessionService.user?.permessions == 'ADMINISTRATOR'">AMMINISTRATORE - </span>COMMERCIALE - I MIEI INVESTIMENTI - CONTRATTO N. {{ currentContract?.id }}</span>
                </ion-title>
            </ion-col>
        </ion-row>
    </ion-toolbar>
</ion-header>

<ion-content>
    <div class="estimates-empty-div">
        <ion-item lines="none" class="estimates">

            <div slot="end" class="edit-icon"
                 *ngIf="sessionService.user.role === sessionService.permissionType.ADMINISTRATOR || currentContract?.status !==contractStatus.ACTIVE">
                <span class="custom-icon-edit-icon" (click)="editContract()"></span>
                <span class="custom-icon-delete-icon" (click)="deleteContract(currentContract.id)"></span>
            </div>

        </ion-item>
    </div>
    <div class="estimates-content-div">
        <div class="profile-list payslip">
            <img src="./assets/imgs/Logo-new.png" class="paySlipLogo">

            <ion-row>
                <ion-col>
                    <h5 class="inv-company head-name">Status: {{ currentContract?.status }}</h5>
                </ion-col>
            </ion-row>

            <ion-row>
                <ion-col>
                    <div class="invoice-details1">
                        <h5 class="inv-company head-name">Created Date
                            <span>{{ currentContract?.date | date : 'd MMM y'}}</span>
                        </h5>
                    </div>
                </ion-col>
                <ion-col class="text-center">
                    <div class="invoice-details1">
                        <h5 class="inv-company head-name">Start Date
                            <span>{{ currentContract?.startDate | date : 'd MMM y'}}</span>
                        </h5>
                    </div>
                </ion-col>
                <ion-col>
                    <div class="invoice-details">
                        <h5 class="inv-company head-name">End Date
                            <span>{{ currentContract?.endDate | date : 'd MMM y'}}</span>
                        </h5>
                    </div>
                </ion-col>
            </ion-row>

            <ion-row>
                <ion-col>
                    <h5 class="inv-company head-name">Added by</h5>
                    <div class="inv-receiver">
                        <h3 class="inv-receiver-address">{{ currentContract?.userContractsAddedId }} {{ currentContract?.commercial.lastname }}</h3>
                    </div>
                </ion-col>
                <ion-col class="text-center">
                    <h5 class="inv-company head-name">Client</h5>
                    <div class="inv-receiver">
                        <h3 class="inv-receiver-address">{{ currentContract?.client.name }} {{ currentContract?.client.lastname }}</h3>
                    </div>
                </ion-col>
                <ion-col class="inv-recieve">
                    <h5 class="inv-company head-name">Amount</h5>
                    <div class="inv-receiver">
                        <h3 class="inv-receiver-address">{{ currentContract?.amount | currency:'EUR' }}</h3>
                    </div>
                </ion-col>
            </ion-row>

            <ion-row>
                <ion-col>
                    <h5 class="inv-company head-name">Product</h5>
                    <h3 class="inv-receiver-address">{{ currentContract?.product }}</h3>
                </ion-col>
            </ion-row>

            <ion-row>
                <ion-col>
                    <h5 class="inv-company head-name">Notes</h5>
                    <h3 class="inv-receiver-address">{{ currentContract?.notes }}</h3>
                </ion-col>
            </ion-row>


            <br>
            <ion-row>
                <ion-button class="centered" color="primary" (click)="open(currentContract?.file)">
                    View document
                </ion-button>
            </ion-row>
        </div>
    </div>
</ion-content> -->
